import React, { Component } from 'react'
import intl from 'react-intl-universal'
import Page from './Page'
import Loading from '../components/Loading'
import Search from '../components/Search'
import ResultsInnerExperience from '../components/ResultsInnerExperience'
import shortid from 'shortid'
import { inject, observer, PropTypes } from 'mobx-react/index'
import return_html from '../api/return_html'

@inject('experiencesSearch')
@observer
class ResultsPage extends Component {
  constructor (props) {
    super(props)

    const {experiencesSearch} = props
    experiencesSearch.request()
  }

  render () {
    const {experiencesSearch} = this.props
    let {status, status_message, sorted_experiences} = experiencesSearch
    const experiences = sorted_experiences

    console.log('render - experiencesSearch:', experiencesSearch)

    status_message = status_message ? status_message.toString() : 'error'

    return (
      <Page title='Results'>

        <div className='b-search-small'>
          <Search type='form' />
        </div>

        <Search />

        {status === 'error' &&
        <article className='b-info'>
          <h2 className='b-info-title'>Something went wrong :(</h2>
          <p>
            <button className='b-button'
                    onClick={this.handleRestart}>Retry
            </button>
          </p>
          <h3 className='b-info-subtitle'>Error</h3>
          <code dangerouslySetInnerHTML={return_html(status_message)} />
        </article>}

        {status === 'loading' && <div><Loading /></div>}

        {(!status || status === 'success') &&
        <section className='b-experiences b-experiences_mosaic'>
          <div className='b-experiences-group' key={shortid.generate()}>
            <div className='b-experiences-group-inner'>
              <div className='b-experiences-group-container'>
                {Array.isArray(experiences) && experiences.length > 0
                  ? experiences.map((experience, index) =>
                    <ResultsInnerExperience experience={experience}
                                            key={shortid.generate()}
                                            show_liked={true}
                                            show_price={true}
                                            show_table={false}
                                            show_rating={true}
                                            show_guests={false}
                                            show_user={false} />)
                  : <div className='b-empty'><div className='b-empty-text'>{intl.get('No experiences')}</div></div>}
              </div>
            </div>
          </div>
        </section>}

      </Page>
    )
  }
}

ResultsPage.propTypes = {
  experiencesSearch: PropTypes.observableObject
}

export default ResultsPage



// WEBPACK FOOTER //
// ./src/containers/ResultsPage.js